/* facts-buybox.js · FACTS PDP Buy-Box behaviour
 * Only swaps the hidden selling_plan / quantity + CTA total on plan change,
 * and drives the nutrition dialog. Cart add + drawer are handled by the
 * theme's own <product-form> element (reads this form's FormData on submit).
 */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.fpbInit === '1') return;
    root.dataset.fpbInit = '1';

    var spInput = root.querySelector('[data-sp-input]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var variantInput = root.querySelector('input[name="id"]');
    var variantId = (root.getAttribute('data-product-variant-id') || '').trim();
    var ctaTotal = root.querySelector('[data-cta-total]');
    var stickyTotal = root.querySelector('[data-sticky-total]');
    /* Julian 03.09.: auf dem Desktop steht der volle Planname. Dafuer liegen
       ZWEI Auswahlfelder im Markup (Kurzname mobil, voller Titel Desktop),
       von denen immer eines sichtbar ist. Beide werden nachgezogen, beide
       schalten dieselben Radios - deshalb hier alle statt nur des ersten.
       Mit `querySelector` haette das versteckte Feld einen alten Stand
       behalten und ihn beim naechsten Fensterwechsel gezeigt. */
    var stickySels = Array.prototype.slice.call(root.querySelectorAll('[data-sticky-select]'));
    /* Die Spar-Marke der Leiste hat keine eigene Quelle: sie steht als
       data-badge am Radio und kommt aus derselben Rechnung wie die Marke
       auf der Karte. Leer heisst weg, nicht leerer Kasten. */
    var stickyBadge = root.querySelector('[data-sticky-badge]');
    /* Der Grundpreis haengt an der gewaehlten Option, nicht an der Seite:
       wer von 90 auf 30 Tage wechselt, zahlt je Packung mehr und damit auch
       je Kilogramm. Dieselbe Mechanik wie beim Preis im Kaufknopf. */
    var baseTotal = root.querySelector('[data-base-total]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-plan]'));
    var quantities = Array.prototype.slice.call(root.querySelectorAll('[data-quantity]'));
    var quantityPanel = root.querySelector('[data-quantity-panel]');
    var onceRadio = radios.filter(function (r) { return !r.dataset.sp; })[0];
    var bulkStatus = root.querySelector('[data-bulk-status]');
    var purchaseButtons = Array.prototype.slice.call(root.querySelectorAll('.fpb__cta'));
    var available = purchaseButtons.length > 0 && !purchaseButtons[0].disabled;
    var bulkBlocked = false;

    function selectedQuantity() {
      return quantities.filter(function (q) { return q.checked; })[0];
    }

    function updateQuantity() {
      var choice = selectedQuantity();
      if (!choice || !onceRadio) return;
      ['qty', 'cta', 'base', 'badge'].forEach(function (key) {
        onceRadio.dataset[key] = choice.dataset[key] || '';
      });
      var total = root.querySelector('[data-once-total]');
      var compare = root.querySelector('[data-once-compare]');
      var day = root.querySelector('[data-once-day]');
      if (total) total.textContent = choice.dataset.cta;
      if (compare) {
        compare.textContent = choice.dataset.compare;
        compare.hidden = choice.dataset.discounted !== 'true';
      }
      if (day) {
        day.textContent = choice.dataset.day;
        day.hidden = false;
      }
      stickySels.forEach(function (select) {
        var option = select.options[radios.indexOf(onceRadio)];
        if (!option) return;
        if (!option.dataset.originalLabel) option.dataset.originalLabel = option.textContent;
        option.textContent = option.dataset.originalLabel + (choice.value === '1' ? '' : ' · ' + choice.value + '×');
      });
    }

    function ensureVariantId() {
      if (!variantInput || !variantId) return;
      variantInput.value = variantId;
      variantInput.setAttribute('value', variantId);
      variantInput.disabled = false;
    }

    function apply(radio) {
      if (!radio) return;
      updateQuantity();
      var sp = (radio.getAttribute('data-sp') || '').trim();
      var qty = radio.getAttribute('data-qty') || '1';
      var cta = radio.getAttribute('data-cta') || '';
      var base = radio.getAttribute('data-base') || '';

      // selling_plan: enable + set for subscriptions, disable for one-time
      if (spInput) {
        if (sp) {
          spInput.value = sp;
          spInput.disabled = false;
        } else {
          spInput.value = '';
          spInput.disabled = true;
        }
      }
      if (qtyInput) qtyInput.value = qty;
      if (ctaTotal && cta) ctaTotal.innerHTML = cta;
      // Die Leiste hat keine eigene Auswahl - sie spiegelt die hier
      // getroffene. Der Planname kommt aus der Karte selbst, damit es
      // keine zweite Textquelle gibt, die auseinanderlaufen kann.
      if (stickyTotal && cta) stickyTotal.innerHTML = cta;
      // Das Auswahlfeld der Leiste fuehrt KEINEN eigenen Zustand - es wird auf
      // den gerade gewaehlten Radio nachgezogen. Damit kann es gar nicht etwas
      // anderes anzeigen als das, was der Knopf in den Warenkorb legt.
      var idx = radios.indexOf(radio);
      if (idx > -1) {
        stickySels.forEach(function (sel) {
          if (sel.selectedIndex !== idx) sel.selectedIndex = idx;
        });
      }
      if (stickyBadge) {
        var badge = radio.getAttribute('data-badge') || '';
        stickyBadge.textContent = badge;
        stickyBadge.hidden = !badge;
      }
      if (baseTotal && base) baseTotal.textContent = base;

      // selected styling
      options.forEach(function (opt) {
        var input = opt.querySelector('[data-plan]');
        opt.classList.toggle('is-selected', !!input && input.checked);
        if (input) input.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
        var details = opt.querySelector('[data-plan-details]');
        if (details) details.hidden = !input || !input.checked;
      });
      var choice = selectedQuantity();
      bulkBlocked = !sp && choice && choice.dataset.discounted === 'true' &&
        quantityPanel && quantityPanel.dataset.checkoutReady !== 'true';
      if (bulkStatus) bulkStatus.hidden = !bulkBlocked;
      purchaseButtons.forEach(function (button) {
        button.disabled = !available || !!bulkBlocked;
        button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      });
    }

    function syncFormFields() {
      ensureVariantId();
      var selected = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      if (selected) apply(selected);
    }

    ensureVariantId();
    var productForm = root.querySelector('product-form form');
    if (productForm) {
      /* Refresh before the theme's product-form serialises FormData. Some
         themes normalise hidden inputs after the section script has run. */
      productForm.addEventListener('submit', function (event) {
        syncFormFields();
        if (bulkBlocked || !available) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      Array.prototype.slice.call(productForm.querySelectorAll('[type="submit"]')).forEach(function (button) {
        button.addEventListener('click', syncFormFields, true);
      });
    }

    stickySels.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var r = radios[sel.selectedIndex];
        if (!r) return;
        r.checked = true;
        apply(r);
      });
    });

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r); });
    });
    quantities.forEach(function (choice) {
      choice.addEventListener('change', function () {
        if (!choice.checked || !onceRadio) return;
        onceRadio.checked = true;
        apply(onceRadio);
      });
    });

    // Initialise from the pre-checked radio (falls back to first)
    var checked = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    if (checked) { checked.checked = true; apply(checked); }
    /* Re-apply once custom elements have completed their own initialisation. */
    window.setTimeout(syncFormFields, 0);
    window.setTimeout(syncFormFields, 250);

    initDialog(root);
    initSticky(root);
  }

  // ---------- KLEBENDE KAUFLEISTE ----------
  // Sichtbar, sobald der Hauptknopf NACH OBEN aus dem Bild gelaufen ist.
  // Nur nach oben: verlaesst der Knopf das Bild nach unten, hat der Nutzer
  // ihn noch gar nicht erreicht - eine Leiste waere dort die Wiederholung
  // von etwas, das gleich ohnehin kommt.
  function initSticky(root) {
    var bar = root.querySelector('[data-fpb-sticky]');
    var cta = root.querySelector('.fpb__cta:not(.fpb__sticky-cta)');
    if (!bar || !cta) return;

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        var e = es[i];
        var obenRaus = e.boundingClientRect.top < 0;
        bar.hidden = !(obenRaus && !e.isIntersecting);
      }
    }, { threshold: 0 }).observe(cta);
  }

  function initDialog(root) {
    /* ---- Galerie: mobil wischen, und die Punkte wandern mit ----
       Auf dem Telefon liegt die Buehne als Wischspur vor. Ohne dieses
       Stueck laesst sie sich zwar wischen, aber Punkte und Pfeile wuessten
       nichts davon. Zwei Richtungen, gegen eine Rueckkopplung gesperrt:
       Punkt geklickt -> Spur scrollt; gewischt -> Radio wird gesetzt.
       Das Setzen von .checked loest KEIN change-Ereignis aus, deshalb
       genuegt die Sperre gegen das eigene Scrollen. */
    var track = root.querySelector('.fpb__stage');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.fpb__slide'));
    var galRadios = Array.prototype.slice.call(root.querySelectorAll('.fpb__galradio'));
    // Only download hidden gallery images when selected or actually swiped into view.
    function loadSlide(slide) {
      if (!slide) return;
      slide.querySelectorAll('img[data-fpb-src]').forEach(function (img) {
        if (img.dataset.fpbSrcset) img.srcset = img.dataset.fpbSrcset;
        img.src = img.dataset.fpbSrc;
        img.removeAttribute('data-fpb-src');
        img.removeAttribute('data-fpb-srcset');
      });
    }
    galRadios.forEach(function (radio, index) {
      radio.addEventListener('change', function () { if (radio.checked) loadSlide(slides[index]); });
      if (radio.checked) loadSlide(slides[index]);
    });
    if (track && 'IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { loadSlide(entry.target); imageObserver.unobserve(entry.target); }
        });
      }, { root: track, threshold: 0.01 });
      slides.forEach(function (slide) { imageObserver.observe(slide); });
    } else {
      slides.forEach(loadSlide);
    }

    if (track && slides.length && slides.length === galRadios.length) {
      var narrow = window.matchMedia('(max-width:1019px)');
      var busy = 0;

      galRadios.forEach(function (r, i) {
        r.addEventListener('change', function () {
          if (!narrow.matches || busy) return;
          busy = 1;
          var left = slides[i].offsetLeft - slides[0].offsetLeft;
          if (track.scrollTo) {
            track.scrollTo({ left: left, behavior: 'smooth' });
          } else {
            track.scrollLeft = left;
          }
          window.setTimeout(function () { busy = 0; }, 450);
        });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!narrow.matches || busy) return;
          entries.forEach(function (e) {
            if (!e.isIntersecting || e.intersectionRatio < 0.55) return;
            var i = slides.indexOf(e.target);
            if (i >= 0 && !galRadios[i].checked) galRadios[i].checked = true;
          });
        }, { root: track, threshold: [0.55] });
        slides.forEach(function (sl) { io.observe(sl); });
      }
    }

    if (root.classList.contains('fpb--clarity')) {
      initClarityDialogs(root);
      return;
    }

    var dialog = root.querySelector('[data-nutri-dialog]');
    var openBtn = root.querySelector('[data-nutri-open]');
    if (!dialog || !openBtn) return;
    var closers = Array.prototype.slice.call(root.querySelectorAll('[data-nutri-close]'));
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      dialog.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var c = dialog.querySelector('.fpb__dialog-close');
      if (c) c.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      dialog.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    openBtn.addEventListener('click', open);
    closers.forEach(function (el) { el.addEventListener('click', close); });
  }


  function initClarityDialogs(root) {
    var lab = root.querySelector('[data-lab-dialog]');
    var nutri = root.querySelector('[data-nutri-dialog]');
    var lastFocus = null;
    var savedOverflow = '';
    var active = null;

    function restore() {
      document.documentElement.style.overflow = savedOverflow;
      document.removeEventListener('keydown', onKey);
      active = null;
      if (lastFocus && lastFocus.isConnected) lastFocus.focus();
    }
    function close() {
      if (!active) return;
      if (active === lab) lab.close();
      else { nutri.hidden = true; restore(); }
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab' || !active || active === lab) return;
      var controls = Array.prototype.slice.call(active.querySelectorAll('button, a[href], summary, input, select, textarea, [tabindex="0"]')).filter(function (el) { return !el.disabled && el.getClientRects().length; });
      var first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open(dialog, trigger) {
      if (!dialog || active) return;
      active = dialog;
      lastFocus = trigger;
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      if (dialog === lab) {
        lab.querySelectorAll('[data-lab-page]').forEach(function (image) { if (!image.getAttribute('src')) image.src = image.dataset.src; });
        lab.showModal();
        lab.querySelector('[data-lab-close]').focus();
      } else {
        dialog.hidden = false;
        dialog.querySelector('[data-nutri-close].fpb__dialog-close').focus();
      }
      document.addEventListener('keydown', onKey);
    }
    root.querySelectorAll('[data-nutri-open]').forEach(function (button) { button.addEventListener('click', function () { open(nutri, button); }); });
    root.querySelectorAll('[data-nutri-close]').forEach(function (button) { button.addEventListener('click', close); });
    root.querySelectorAll('[data-lab-open]').forEach(function (button) { button.addEventListener('click', function (e) { if (lab && lab.showModal) { e.preventDefault(); open(lab, button); } }); });
    if (lab) {
      lab.querySelector('[data-lab-close]').addEventListener('click', close);
      lab.addEventListener('close', restore);
      lab.addEventListener('click', function (e) { if (e.target !== lab) return; var box = lab.getBoundingClientRect(); if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) close(); });
    }
    root.querySelectorAll('[data-clarity-claim]').forEach(function (link) {
      link.addEventListener('click', function () {
        var target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        var detail = target.closest('details');
        if (detail) detail.open = true;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="facts-product-buybox"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="facts-product-buybox"]');
    if (el) initSection(el);
  });
})();

